import {inject, Injectable} from '@angular/core';
import {I18nService, ProjectService, StudioFactory, ThemeService} from "@wms/services";
import {PrefabManager} from "@wms/page-workspace";
import {get, groupBy} from "lodash-es";
import {replace} from "@wm/core";
import {ArtifactsService} from "@wms/settings/artifacts";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ProjectUpdatesService {
  locale: any;
  projectDetails: any;
  showUpdatesAvailableNotification = false;
  prefabConflicts: any[] = [];
  themeConflicts: any[] = [];
  sourceCodeUpdates: any[] = [];
  updatesInfo: {
    updatesCount: number,
    artifactsUpdatesCount: number,
    sourceCodeUpdatesCount: number,
    hasVcsUpdates: boolean
  } = {
    updatesCount: 0,
    artifactsUpdatesCount: 0,
    sourceCodeUpdatesCount: 0,
    hasVcsUpdates: false
  };
  invalidRepoBranchInfo: string = '';
  isInvalidRemoteSubject = new BehaviorSubject<string>('');
  isInvalidRemoteRepo = this.isInvalidRemoteSubject.asObservable();

  private studioFactory = inject(StudioFactory);
  private themeService = inject(ThemeService);
  private prefabManager = inject(PrefabManager);
  private artifactsService = inject(ArtifactsService);
  private i18nService = inject(I18nService);
  private projectService = inject(ProjectService);

  constructor() {
    this.locale = this.i18nService.getMessages();
    this.projectDetails = this.projectService.getDetails();
  }

  init(): void {
    this.themeService.loadThemes(false).then(() => {
      this.themeService.getProjectThemesList().then(() => {
        Promise.all([this.themeService.getThemeVersionConflicts(), this.projectService.getProjectUpdates()])
          .then(([themeConflicts, projectUpdatesConflicts]) => {
            const projectUpdatesList = groupBy(projectUpdatesConflicts, 'type');
            if(projectUpdatesList['REPOSITORY_NOT_FOUND'] || projectUpdatesList['BRANCH_NOT_FOUND'] || projectUpdatesList['USER_VCS_CREDENTIALS_REQUIRED']) {
              this.invalidRepoBranchInfo = projectUpdatesConflicts[0].type;
              this.isInvalidRemoteSubject.next(this.invalidRepoBranchInfo);
            }
            let prefabUpdatesList=[];
            if(projectUpdatesList['PREFAB_UPDATES']) {
              prefabUpdatesList = projectUpdatesList['PREFAB_UPDATES'][0].data.prefabUpdatesVOList;
            }
            this.updatesInfo.hasVcsUpdates = !!projectUpdatesList['PULL_REQUIRED'];
            if (this.updatesInfo.hasVcsUpdates) {
              this.updatesInfo.updatesCount += 1;
            }

            if(!!projectUpdatesList['RE_IMPORT_DB'] || !!projectUpdatesList['RE_IMPORT_SERVICE']) {
              this.sourceCodeUpdates = (projectUpdatesList['RE_IMPORT_DB'] || []).concat(projectUpdatesList['RE_IMPORT_SERVICE'] || []);
              this.updatesInfo.updatesCount += 1;
              this.updatesInfo.sourceCodeUpdatesCount = this.sourceCodeUpdates.length;
              this.sourceCodeUpdates.forEach(update => {
                if(update.type === 'RE_IMPORT_DB') {
                  update.discription =  update.data.message + " " + replace(this.locale.MESSAGE_SOURCE_CODE_UPDATES, [update.data.serviceId]);
                } else {
                  const skipCodeGen = (get(this.projectDetails, 'properties.skipSwaggerCodeGen') === 'true' || get(this.projectDetails, 'properties.skipSwaggerCodeGen') === true) ? true : false;
                  update.discription =  skipCodeGen ? get(update, 'data.serviceAction.message') : replace(this.locale.MESSAGE_SOURCE_CODE_UPDATES, [update.data.serviceId]);
                }
              });
            }

            if(prefabUpdatesList.length || themeConflicts.length) {
              this.prefabConflicts =prefabUpdatesList;
              this.themeConflicts = themeConflicts;
              this.updatesInfo.updatesCount += 1;
              this.updatesInfo.artifactsUpdatesCount = prefabUpdatesList.length + themeConflicts.length;
            }

            if (!!this.updatesInfo.updatesCount) {
              this.showUpdatesAvailableNotification = true;
            }
          });
      });
    });
  }

}
